// @flow

import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/css/bootstrap-theme.css"
import React from "react"
import { render } from "react-snapshot"
import * as firebase from "firebase"
import "firebase/firestore"
import { BrowserRouter } from "react-router-dom"
import "./index.css"
import Shell from "./Shell"
import { unregister } from "./registerServiceWorker"
import ScrollToTop from "./misc/ScrollToTop"
import * as SmoothScroll from "smooth-scroll"
import * as analytics from "./analytics"

analytics.init()

firebase.initializeApp({
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
})

render(
	<BrowserRouter>
		<ScrollToTop>
			<Shell />
		</ScrollToTop>
	</BrowserRouter>,
	document.getElementById("root")
)
unregister() // Disable service workers for now, breaks Crisp

new SmoothScroll("[data-scroll]")



// WEBPACK FOOTER //
// ./src/index.js